import axios from "axios";

export default axios.create({
  baseURL: "https://api.cloudinary.com/v1_1/drasrbm3r/image/",
});
